import { useState } from 'react';

const navLinks = [
  { label: '首页', href: '#home' },
  { label: '题材分类', href: '#categories' },
  { label: '热门推荐', href: '#featured' },
  { label: '排行榜', href: '#rankings' },
  { label: '每日更新', href: '#updates' },
  { label: '完结作品', href: '#completed' },
  { label: '关于我们', href: '#about' },
];

interface NavbarProps {
  query: string;
  onQueryChange: (v: string) => void;
  onSearch: () => void;
}

export default function Navbar({ query, onQueryChange, onSearch }: NavbarProps) {
  const [open, setOpen] = useState(false);

  const submitSearch = () => {
    onSearch();
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-40 w-full bg-background-50/90 backdrop-blur-md border-b border-background-200">
      <div className="mx-auto flex h-16 md:h-[72px] items-center justify-between px-4 md:px-8 gap-4">
        <a href="#home" className="flex items-center gap-2.5 shrink-0" aria-label="漫阅韩漫首页">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg md:text-xl w-5 h-5 flex items-center justify-center" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg md:text-xl text-foreground-950">漫阅韩漫</span>
            <span className="text-[10px] md:text-xs text-foreground-500 mt-0.5 tracking-widest">HANREAD</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 font-medium whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <form
            className="relative"
            onSubmit={(e) => {
              e.preventDefault();
              submitSearch();
            }}
            role="search"
            aria-label="站内搜索"
          >
            <input
              type="text"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder="搜索作品 / 作者"
              className="w-52 pl-9 pr-3 py-2 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400 w-4 h-4 flex items-center justify-center" />
          </form>
          <a
            href="#subscribe"
            className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 whitespace-nowrap"
          >
            订阅更新
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-800 cursor-pointer"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={`ri-${open ? 'close' : 'menu'}-line text-xl w-5 h-5 flex items-center justify-center`} />
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <form
            className="relative mb-3"
            onSubmit={(e) => {
              e.preventDefault();
              submitSearch();
            }}
            role="search"
            aria-label="站内搜索"
          >
            <input
              type="text"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder="搜索作品 / 作者"
              className="w-full pl-9 pr-3 py-2.5 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400 w-4 h-4 flex items-center justify-center" />
          </form>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 font-medium"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 px-4 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold text-center"
            >
              订阅更新
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}